import React from 'react';
import { Link } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { FctCabecera, FctIcono } from '../../fct/react';
import { fctTema } from '../../fct/antd/theme';

/**
 * GcPagina — cabecera de contexto de una pantalla de GescomAux (manual v0.9.1, R-06):
 * camino con el isotipo de entorno en una tinta («gescom.aux / Sección»), título de página,
 * contexto y acciones (como mucho un primario). En las pantallas de detalle, `volver` añade
 * la salida explícita al listado. El contenido va debajo, sobre el lienzo.
 *
 * Densidad (regla 14): `compacta` para listados y tablas (controles de 32 px, celdas estrechas),
 * `comoda` (por defecto) para fichas, formularios y asistentes.
 */
export interface GcPaginaProps {
  /** Sección del camino bajo «gescom.aux» (p. ej. «Conciliación»). */
  seccion?: string | string[];
  titulo: string;
  contexto?: React.ReactNode;
  acciones?: React.ReactNode;
  /** Salida explícita (pantallas de detalle). */
  volver?: { to: string; etiqueta: string };
  densidad?: 'comoda' | 'compacta';
  children?: React.ReactNode;
}

const GcPagina: React.FC<GcPaginaProps> = ({ seccion, titulo, contexto, acciones, volver, densidad = 'comoda', children }) => {
  const camino = seccion === undefined ? [] : Array.isArray(seccion) ? seccion : [seccion];
  const contenido = densidad === 'compacta'
    ? <ConfigProvider theme={fctTema('interna', 'compacta')}><div className="fct-compacta">{children}</div></ConfigProvider>
    : children;
  return (
    <div className="gc-pagina">
      {volver && (
        <Link to={volver.to} className="gc-volver">
          <FctIcono nombre="volver" />
          {volver.etiqueta}
        </Link>
      )}
      <FctCabecera
        entorno={{ nombre: 'gescom.aux', forma: '2x4-06' }}
        camino={camino}
        titulo={titulo}
        contexto={contexto}
        acciones={acciones}
      />
      {contenido}
    </div>
  );
};

export default GcPagina;
